<style scoped>
    #wage-excel-input{
        display: none;
    }
    .ivu-form-item{
        margin-bottom: 0;
    }
</style>
<template>
  <div>
    <div class="line">
      <DatePicker
        size="small"
        type="month"
        :value="params.month"
        style="width: 100px"
        placeholder="选择月份"
        @on-change="monthChange"
      />
      <space />
      <label
        :class="`ivu-btn ${ params.month?'ivu-btn-primary':'ivu-btn-warning'} ivu-btn-small`"
        :for="params.month?'wage-excel-input':'wage-excel-input-'"
        @click="clickWageInput"
      >
        <Icon type="android-upload" />
        导入数据
      </label>
    </div>
    <div>
      <Button
        type="primary"
        size="small"
        :loading="getting_sms"
        :disabled="sms_timeout > 0 || getting_sms"
        @click="getSmsCode"
      >
        <span>{{ sms_btn_text }}</span>
      </Button>
      <space />
      <i-input
        v-model="params.code"
        size="small"
        placeholder="输入验证码"
        style="width: 100px"
      />
      <space />
      <Button
        :type="params.month&&params.code?'primary':'warning'"
        size="small"
        :loading="loading"
        @click="getRecords"
      >
        <span>查看社保公积金信息</span>
      </Button>
      <space />
      <!--  :disabled="!records.length" -->
      <Button
        size="small"
        icon="md-download"
       
        @click="exportCsv()"
      >
        导出数据
      </Button>
    </div>
    <div class="line">
      验证码10分钟内有效, 无需重复获取
    </div>

    <div class="line">
      <input
        id="wage-excel-input"
        ref="importInput"
        type="file"
        @focus="importFocus"
        @change="importFile"
      >
      <div
        v-show="import_processing"
        class="line"
      >
        <Progress
          :percent="import_percent"
          status="active"
        />
      </div>
    </div>
    <div class="line">
      <Table
        ref="table"
        border
        
        :no-data-text="no_data_text"
        :loading="loading"
        :columns="wage_columns"
        :data="records"
        size="small"
      />
    </div>
  </div>
</template>
<script route="/wage/social_record">
  import WageUtil from './libs/util';
  import {mapGetters} from "vuex";
  import { formattingNumber } from '@/libs/util.js'
  function getTargetData(h, key, target) {
    return h('span', formattingNumber(target[key], 2))
  }
  export default {
    data() {
      return {
        params: {
          month: '',
          code: '',
        },
        import_processing: false,
        import_percent: 0,
        getting_sms: false,
        sms_timeout: 0,
        loading: false,
        records: [],
        no_data_text: '输入[验证码], 点击查看按钮加载工资数据'
      }
    },
    computed: {
      ...mapGetters({
        companies_hash: 'async/companies_hash',
      }),
      wage_columns() {
        let columns = [
          {
            title: '费用所属期',
            align: 'center',
            fixed: 'left',
            width: 80,
            key: 'month'
          },
          {
            title: '单位名称',
            align: 'center',
            fixed: 'left',
            minWidth: 120,
            key: 'company_name',
            render: (h, params) => {
              const row = params.row;
              const company = this.companies_hash[row.company_id];
              return h('span', company ? company.short_name : '-');
            }
          },
          {
            title: '工号',
            align: 'center',
            key: 'uid',
            width: 65,
          },
          {
            title: '姓名',
            width: 80,
            align: 'center',
            key: 'account'
          },
          {
            title: '社保申报基数',
            width: 120,
            align: 'right',
            key: 'ssb',
            render: (h, {row}) => {
              return getTargetData(h, 'ssb', row && row.content || {});
            }
          },
          {
            title: '养老基数',
            width: 120,
            align: 'right',
            key: 'esb',
            render: (h, {row}) => {
              return getTargetData(h, 'esb', row && row.content || {});
            }
          },
          {
            title: '医疗+生育基数',
            width: 120,
            align: 'right',
            key: 'mbsb',
            render: (h, {row}) => {
              return getTargetData(h, 'mbsb', row && row.content || {});
            }
          },
          {
            title: '工伤+失业基数',
            width: 120,
            align: 'right',
            key: 'iusb',
            render: (h, {row}) => {
              return getTargetData(h, 'iusb', row && row.content || {});
            }
          },
          {
            title: '公积金申报基数',
            width: 120,
            align: 'right',
            key: 'hfb',
            render: (h, {row}) => {
              return getTargetData(h, 'hfb', row && row.content || {});
            }
          },
          {
            title: '公积金执行基数',
            width: 120,
            align: 'right',
            key: 'hfeb',
            render: (h, {row}) => {
              return getTargetData(h, 'hfeb', row && row.content || {});
            }
          },
          {
            title: '养老单位',
            width: 120,
            align: 'right',
            key: 'eic',
            render: (h, {row}) => {
              return getTargetData(h, 'eic', row && row.content || {});
            }
          },
          {
            title: '养老个人',
            width: 120,
            align: 'right',
            key: 'eip',
            render: (h, {row}) => {
              return getTargetData(h, 'eip', row && row.content || {});
            }
          },
          {
            title: '养老合计',
            width: 120,
            align: 'right',
            key: 'eis',
            render: (h, {row}) => {
              return getTargetData(h, 'eis', row && row.content || {});
            }
          },
          // di
          {
            title: '医疗单位',
            width: 120,
            align: 'right',
            key: 'mic',
            render: (h, {row}) => {
              return getTargetData(h, 'mic', row && row.content || {});
            }
          },
          {
            title: '医疗个人',
            width: 120,
            align: 'right',
            key: 'mip',
            render: (h, {row}) => {
              return getTargetData(h, 'mip', row && row.content || {});
            }
          },
          {
            title: '医疗合计',
            width: 120,
            align: 'right',
            key: 'mis',
            render: (h, {row}) => {
              return getTargetData(h, 'mis', row && row.content || {});
            }
          },
          {
            title: '大病单位',
            width: 120,
            align: 'right',
            key: 'ciic',
            render: (h, {row}) => {
              return getTargetData(h, 'ciic', row && row.content || {});
            }
          },
          {
            title: '生育单位',
            width: 120,
            align: 'right',
            key: 'bic',
            render: (h, {row}) => {
              return getTargetData(h, 'bic', row && row.content || {});
            }
          },
          {
            title: '失业单位',
            width: 120,
            align: 'right',
            key: 'uic',
            render: (h, {row}) => {
              return getTargetData(h, 'uic', row && row.content || {});
            }
          },
          {
            title: '失业个人',
            width: 120,
            align: 'right',
            key: 'uip',
            render: (h, {row}) => {
              return getTargetData(h, 'uip', row && row.content || {});
            }
          },
          {
            title: '失业合计',
            width: 120,
            align: 'right',
            key: 'uis',
            render: (h, {row}) => {
              return getTargetData(h, 'uis', row && row.content || {});
            }
          },
          {
            title: '工伤单位',
            width: 120,
            align: 'right',
            key: 'iic',
            render: (h, {row}) => {
              return getTargetData(h, 'iic', row && row.content || {});
            }
          },
          {
            title: '社保单位',
            width: 120,
            align: 'right',
            key: 'sic',
            render: (h, {row}) => {
              return getTargetData(h, 'sic', row && row.content || {});
            }
          },
          {
            title: '社保个人',
            width: 120,
            align: 'right',
            key: 'sip',
            render: (h, {row}) => {
              return getTargetData(h, 'sip', row && row.content || {});
            }
          },
          {
            title: '社保合计',
            width: 120,
            align: 'right',
            key: 'sis',
            render: (h, {row}) => {
              return getTargetData(h, 'sis', row && row.content || {});
            }
          },
          {
            title: '公积金单位',
            width: 120,
            align: 'right',
            key: 'hfc',
            render: (h, {row}) => {
              return getTargetData(h, 'hfc', row && row.content || {});
            }
          },
          {
            title: '公积金个人',
            width: 120,
            align: 'right',
            key: 'hfp',
            render: (h, {row}) => {
              return getTargetData(h, 'hfp', row && row.content || {});
            }
          },
          {
            title: '公积金合计',
            width: 120,
            align: 'right',
            key: 'hfs',
            render: (h, {row}) => {
              return getTargetData(h, 'hfs', row && row.content || {});
            }
          },
          {
            title: '社保公积金单位',
            width: 120,
            align: 'right',
            key: 'sihfc',
            render: (h, {row}) => {
              return getTargetData(h, 'sihfc', row && row.content || {});
            }
          },
          {
            title: '社保公积金个人',
            width: 120,
            align: 'right',
            key: 'sihfp',
            render: (h, {row}) => {
              return getTargetData(h, 'sihfp', row && row.content || {});
            }
          },
          {
            title: '社保公积金合计',
            width: 120,
            align: 'right',
            key: 'sihfs',
            render: (h, {row}) => {
              return getTargetData(h, 'sihfs', row && row.content || {});
            }
          },
          {
            title: '服务费',
            width: 120,
            align: 'right',
            key: 'sf',
            render: (h, {row}) => {
              return getTargetData(h, 'sf', row && row.content || {});
            }
          },
          {
            title: '费用合计',
            width: 120,
            align: 'right',
            key: 'fs',
            render: (h, {row}) => {
              return getTargetData(h, 'fs', row && row.content || {});
            }
          },
          {
            title: '备注',
            width: 200,
            align: 'center',
            key: 'remark',
          },
        ];
  
        columns = columns.concat([
          // {
          //   title: '状态',
          //   align: 'center',
          //   fixed: 'right',
          //   width: 60,
          //   render: (h, params) => {
          //     const row = params.row;
          //     if (row.status === 0) {
          //       return h('span', {
          //         'class': {
          //           'color-success': true
          //         }
          //       }, '正常');
          //     } else if (row.status === 1) {
          //       return h('span', {
          //         'class': {
          //           'color-error': true
          //         }
          //       }, '异常');
          //     }
          //     return h('span', '-');
          //   }
          // },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 80,
            render: (h, { row }) => {
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.delRecord(row || {});
                  }
                }
              }, '删除');
            }
          }
        ]);
        return columns;
      },
      sms_btn_text() {
        if (!this.getting_sms && this.sms_timeout === 0) {
          return '获取验证码';
        }
        if (this.sms_timeout > 0) {
          return `${this.sms_timeout} S`;
        }
        return '获取中...';
      },
    },
    created() {
      //            this.params.month = '2018-07';
      //            this.getRecords();
      //  this.getSocialSecurity();
    },
    mounted() {
      //
    },
    methods: {
      clickWageInput() {
        if (!this.params.month) {
          this.$Message.error('请选择月份');
        }
      },
      // getSocialSecurity() {
      //   WageUtil.getSocialSecurity().then((data) => {
      //     this.items = data.items;
      //   });
      // },
      resetFileInput() {
        this.$refs.importInput.value = '';
      },
      importFocus() {
        this.resetFileInput();
      },
      importFile() {
        const file_path = this.$refs.importInput.value;
        const path_arr = file_path.split('.');
        const extname = path_arr[path_arr.length - 1].toLowerCase();
        if (['xlsx'].indexOf(extname) === -1) {
          this.resetFileInput();
          this.$Modal.warning({title: '提示', content: '请上传Excel文件(后缀名应为xlsx)'});
          return;
        }

        const file = this.$refs.importInput.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('month', this.params.month);

        this.import_processing = true;
        WageUtil.importSocialFile(formData, percent => {
          this.import_percent = percent;
        }).then(() => {
          // this.records = records;
          this.$Modal.success({title: '提示', content: '上传成功'});
        }).catch((e) => {
          this.$Modal.error({
            title: '上传失败',
            content: e.message,
            width: 600
          });
        }).finally(() => {
          this.import_processing = false;
          this.resetFileInput();
        });
      },
      getSmsCode() {
        WageUtil.getSmsCode().then(() => {
          this.sms_timeout = 120;
          this.sms_timer = setInterval(() => {
            this.sms_timeout--;
            if (this.sms_timeout <= 0) {
              clearInterval(this.sms_timer);
            }
          }, 1000);
          this.$Message.success('发送短信成功!');
        });
      },
      monthChange(month) {
        this.params.month = month;
      },
      getRecords() {
        if (!this.params.month) {
          this.$Message.error('请选择月份');
          return;
        }
        if (!this.params.code) {
          this.$Message.error('请填写验证码');
          return;
        }
        this.loading = true;
        WageUtil.getSocialRecords(this.params).then(data => {
          this.handleRecords(data);
          if (this.records.length === 0) {
            this.$Modal.warning({title: '提示', content: '没有查找到工资数据, 如有疑问, 请联系开发!'});
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      handleRecords(records) {
        this.records = [];
        records = records || []
        records.forEach((record) => {
          const company = this.companies_hash[record.company_id];
          record.company_name = company ? company.short_name : '-';
          // const team = this.teams_hash[record.team_id] || {};
          // record.team_name = record.team_name || team.name || '-';
          this.records.push(Object.assign(record, record.content));
        });
      },
      formatPrice(price) {
        return this.$util.formatPrice(price);
      },
      delRecord(record) {
        this.$Modal.confirm({
          title: '提示',
          content: `你确定要删除 ${record.account} 在 ${record.month} 的工资记录吗?`,
          onOk: () => {
            this.loading = true;
            WageUtil.delSocialRecord(record).then(() => {
              this.$Message.success('删除成功');
              this.records.remove(record);
            }).finally(() => {
              this.loading = false;
            });
          }
        })
      },
      exportCsv() {
        const columns = this.$util.clone(this.wage_columns);
        columns.pop();
        // 到处数据不能复现render
        let records = JSON.parse(JSON.stringify(this.records || []))
        records = records.map(record => {
          record = record || {}
          const content = record.content || {}
          const company = this.companies_hash[record.company_id]
          const company_name = company ? company.short_name : '-'
          return {
            ...record,
            ...content,
            company_name,
          }
        })
        this.$refs.table.exportCsv({
          filename: `工资导出-${this.params.month}.csv`,
          columns: columns,
          data: records
        });
      }
    }
  }
</script>
